// removed by extract-text-webpack-plugin
module.exports = {"base":"Paginator_base--3ggm5","control":"Paginator_control--2yNtD","isDisabled":"Paginator_isDisabled--NIGfy","control__prev":"Paginator_control__prev--2sBEc","controlPrev":"Paginator_control__prev--2sBEc","control__next":"Paginator_control__next--1EOBi","controlNext":"Paginator_control__next--1EOBi","current":"Paginator_current--YsZ9I","divider":"Paginator_divider--2oQq7","total":"Paginator_total--11wVN"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-mt-bootstrap/lib/components/Paginator/Paginator.css
// module id = 1825
// module chunks = 16